<!--事件图表-->
<template>
	<div class="eventChartBody">
		<div class="energy-value">
			<vchart ref='eventVchart' style='height: 250px;'></vchart>
		</div>
		<div class="energy-chart">
			<vchart ref='eventTypeVchart' style='height: 250px;'></vchart>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				eventOptions: {
					xAxis: {
						type: 'category',
						data: []
					},
					yAxis: {
						type: 'value',
						max: value => {
							return value.max | 0 + 10
						},
						boundaryGap: [0, '100%'],
						splitLine: {
							show: true
						}
					},
					grid: {
						left: '5%',
						right: '5%',
						bottom: '70'
					},
					legend: {
						data: ['已处理','未处理'],
						type: 'scroll',
						bottom: '20px',
						formatter: function(name) {
							return echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…');
						},
						tooltip: {
							show: true
						},
						selected: {}
					},
					series: [{
						name: '已处理',
						type: 'bar',
						barGap: 0,
						data: []
					}, ]
				},
				eventTypeOptions: {
					legend: {
						orient: 'vertical',
						left: '50px',
						top:'50px',
						data: []
					},
					series: [{
						name: '',
						type: 'pie',
						radius: '55%',
						center: ['50%', '60%'],
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
						label: {
							normal: {
								show: false,
							}
						},
					}]

				},
				eventList: [],
			}
		},
		created() {},
		mounted() {
			this.$refs.eventVchart.setData(this.eventOptions, true)
			this.initeventData()
		},
		destroyed() {},
		computed: {
			searchAllEventTypes() {
				//事件类型
				return this.$store.eventStore.getters.searchAllEventTypes
			},
			nowUnit() {
				//选中的id
				return this.$store.unitStore.getters.getNowUnit
			},
			nowDevice() {
				//当前选中的设备
				return this.$store.deviceStore.state.nowVirtualDevice
			}
		},
		watch: {
			eventList(nv, ov) {
				//事件数据
				let evetnXdata = []
				let wclData = []
				let yclData=[]
				this.eventList.forEach(item => {
					evetnXdata.push(item.dataTime)
					wclData.push(item.wcl)
					yclData.push(item.ycl)
				})
				this.eventOptions.xAxis.data = evetnXdata
				this.eventOptions.series = [{
					name: '未处理',
					type: 'bar',
					barWidth: '30%',
					color: '#2D9FFF',
					data: wclData
				},{
					name: '已处理',
					type: 'bar',
					barWidth: '30%',
					color: '#eba858',
					data: yclData
				}]
				this.$refs.eventVchart.setData(this.eventOptions)
			},
			searchAllEventTypes(nv, ov) {
				this.initeventData()
			}
		},
		methods: {
			initeventData() {
				//事件类型
				let nos = '1,2,1000,1001,1002,1003'
				let typeList = ['越限报警','变位报警','剩余电流告警','高温预警','过负荷告警','电压异常']
				this.eventTypeOptions.legend.data = typeList
				let getDay = new Date().format('yyyy-MM')
				let startTime = new Date(getDay + '--01 00:00:00')
				let endTime = new Date(getDay + '--31 23:59:59')
				let pieData = []
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, nos, -1, '', this.nowDevice.id, startTime.getTime(), endTime.getTime(), '', respon => {
					if(!isempty(respon)) {
						let i = 0
						for(var index in respon) {
							pieData.push({
								value: respon[index],
								name: typeList[i]
							})
							i++
						}
						this.eventTypeOptions.series[0].data = pieData
						this.eventTypeOptions.tooltip = {
							trigger: 'item',
							formatter: '{a} <br/>{b} : {c} ({d}%)'
						}
						this.$refs.eventTypeVchart.setData(this.eventTypeOptions, true)
					}
				})
				//获取月份总数据
				let time = new Date().getTime()
				this.$api.eventApi.countUnitEventsByMonth(time, 6, this.nowUnit.id, respon => {
					this.eventList = []
					respon.forEach(item => {
						this.eventList.push({
							dataTime: new Date(item.time).format('yyyy年MM月'),
							wcl: item.wcl,
							ycl:item.ycl
							
						})
					})
				})
			},
		}
	}
</script>

<style scoped>
	.eventChartBody {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>